import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var FAQ = [{
  language: 'fr-FR',
  url: 'https://faq-france.maisonsdumonde.com'
}, {
  language: 'fr-LU',
  url: 'https://faq-lux.maisonsdumonde.com'
}, {
  language: 'en-GB',
  url: 'https://help-uk.maisonsdumonde.com'
}, {
  language: 'fr-BE',
  url: 'https://faq-belgique.maisonsdumonde.com'
}, {
  language: 'nl-BE',
  url: 'https://faq-belgie.maisonsdumonde.com'
}, {
  language: 'nl-NL',
  url: 'https://faq-nederland.maisonsdumonde.com'
}, {
  language: 'de-DE',
  url: 'https://faq-deutschland.maisonsdumonde.com'
}, {
  language: 'de-AT',
  url: 'https://faq-oesterreich.maisonsdumonde.com'
}, {
  language: 'it-CH',
  url: 'https://faq-svizzera.maisonsdumonde.com'
}, {
  language: 'fr-CH',
  url: 'https://faq-suisse.maisonsdumonde.com'
}, {
  language: 'de-CH',
  url: 'https://faq-schweiz.maisonsdumonde.com'
}, {
  language: 'es-ES',
  url: 'https://faq-es.maisonsdumonde.com'
}, {
  language: 'it-IT',
  url: 'https://faq-italia.maisonsdumonde.com'
}, {
  language: 'pt-PT',
  url: 'https://help-pt.maisonsdumonde.com'
}];
export var DELIVERY_FAQ = {
  'fr-FR': {
    deliveryUrl: 'https://faq-france.maisonsdumonde.com/fr/collections/1235252-livraison'
  },
  'fr-LU': {
    deliveryUrl: 'https://faq-lux.maisonsdumonde.com/fr/collections/1474490-livraison'
  },
  'en-GB': {
    deliveryUrl: 'https://help-uk.maisonsdumonde.com/en/collections/1223095-delivery'
  },
  'fr-BE': {
    deliveryUrl: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1407218-livraison'
  },
  'nl-BE': {
    deliveryUrl: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1464304-levering'
  },
  'nl-NL': {
    deliveryUrl: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1469850-levering'
  },
  'de-DE': {
    deliveryUrl: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1462565-lieferung'
  },
  'de-AT': {
    deliveryUrl: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1471417-lieferung'
  },
  'it-CH': {
    deliveryUrl: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1460829-consegna'
  },
  'fr-CH': {
    deliveryUrl: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1413246-livraison'
  },
  'de-CH': {
    deliveryUrl: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1466189-lieferung'
  },
  'es-ES': {
    deliveryUrl: 'https://faq-es.maisonsdumonde.com/es/collections/1440575-envio'
  },
  'it-IT': {
    deliveryUrl: 'https://faq-italia.maisonsdumonde.com/it/collections/1432865-consegna'
  },
  'pt-PT': {
    deliveryUrl: 'https://help-pt.maisonsdumonde.com/pt/collections/1472882-envio'
  }
};
export var RETURN_FAQ = {
  'fr-FR': {
    returnsUrl: 'https://faq-france.maisonsdumonde.com/fr/collections/1235271-retour-et-remboursement'
  },
  'fr-LU': {
    returnsUrl: 'https://faq-lux.maisonsdumonde.com/fr/collections/1474497-retour-et-remboursement'
  },
  'en-GB': {
    returnsUrl: 'https://help-uk.maisonsdumonde.com/en/collections/1223125-refunds-returns'
  },
  'fr-BE': {
    returnsUrl: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1410739-retour-et-remboursement'
  },
  'nl-BE': {
    returnsUrl: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1464319-retourneren-en-terugbetaling'
  },
  'nl-NL': {
    returnsUrl: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1469867-retourneren-en-terugbetaling'
  },
  'de-DE': {
    returnsUrl: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1462573-retouren-und-erstattungen'
  },
  'de-AT': {
    returnsUrl: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1471424-retouren-und-erstattungen'
  },
  'it-CH': {
    returnsUrl: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1460838-resi-e-rimborsi'
  },
  'fr-CH': {
    returnsUrl: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1413252-retour-et-remboursement'
  },
  'de-CH': {
    returnsUrl: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1466199-retouren-und-erstattungen'
  },
  'es-ES': {
    returnsUrl: 'https://faq-es.maisonsdumonde.com/es/collections/1440576-devolucion-y-reembolso'
  },
  'it-IT': {
    returnsUrl: 'https://faq-italia.maisonsdumonde.com/it/collections/1433177-resi-e-rimborsi'
  },
  'pt-PT': {
    returnsUrl: 'https://help-pt.maisonsdumonde.com/pt/collections/1472887-devolucao-e-reembolso'
  }
};
export var MODULE_FAQ = [{
  language: 'fr-FR',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-france.maisonsdumonde.com/livraison',
      label: 'Livraison'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/retour-et-remboursement',
      label: 'Retour et remboursement'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/produits-et-disponibilite',
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: 'https://faq-france.maisonsdumonde.com/articles/2370783-quel-transporteur-va-me-livrer',
      label: 'Quel transporteur va me livrer ?'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/articles/2158893-quel-est-le-montant-des-frais-de-livraison',
      label: 'Quel est le montant des frais de livraison ?'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/fr/articles/4929096-comment-contacter-mon-vendeur-marketplace',
      label: 'Comment contacter mon vendeur Marketplace ?'
    }],
    ORDERS: [{
      url: 'https://faq-france.maisonsdumonde.com/articles/2364207-quels-sont-les-delais-et-modes-de-remboursement',
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/articles/2159083-puis-je-echanger-en-magasin-un-meuble-commande-par-internet',
      label: 'Puis-je échanger en magasin un article commandé sur internet ?'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/fr/articles/4929096-comment-contacter-mon-vendeur-marketplace',
      label: 'Comment contacter mon vendeur ?'
    }],
    ORDERDETAILS: [{
      url: 'https://faq-france.maisonsdumonde.com/articles/2362321-colissimo-point-de-retrait-quels-sont-les-delais-et-modalites-d-une-livraison',
      label: 'Colissimo: quels sont les délais et modalités de livraison?'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/articles/2362347-geodis-quels-sont-les-delais-et-modalites-d-une-livraison',
      label: 'Geodis: quels sont les délais et modalités de livraison?'
    }],
    GIFTS: [{
      url: 'https://faq-france.maisonsdumonde.com/articles/2353042-existe-il-une-carte-de-fidelite-maisons-du-monde',
      label: 'Existe-t-il une carte de fidélité Maisons du Monde?'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/articles/2349682-je-n-arrive-pas-a-utiliser-ma-carte-cadeau',
      label: 'Je n\'arrive pas à utiliser ma carte cadeau'
    }],
    PROFILE: [{
      url: 'https://faq-france.maisonsdumonde.com/articles/2159100-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles',
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles?'
    }, {
      url: 'https://faq-france.maisonsdumonde.com/articles/2118905-comment-me-desabonner-de-la-newsletter',
      label: 'Comment me désabonner de la newsletter?'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-france.maisonsdumonde.com/livraison'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-france.maisonsdumonde.com/livraison'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-france.maisonsdumonde.com/livraison'
    }]
  }
}, {
  language: 'fr-LU',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-lux.maisonsdumonde.com/fr/collections/1474490-livraison',
      label: 'Livraison'
    }, {
      url: 'https://faq-lux.maisonsdumonde.com/fr/collections/1474497-retour-et-remboursement',
      label: 'Retour et remboursement'
    }, {
      url: 'https://faq-lux.maisonsdumonde.com/fr/collections/1409065-produits-et-disponibilite',
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550988-quel-transporteur-va-me-livrer',
      label: 'quel transporteur va me livrer?'
    }, {
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550938-quel-est-le-montant-des-frais-de-livraison',
      label: 'Quel est le montant des frais de livraison?'
    }],
    ORDERS: [{
      url: 'http://faq-lux.maisonsdumonde.com/articles/2551352-quels-sont-les-delais-et-modes-de-remboursement',
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550950-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin',
      label: 'Quels sont les délais et modalités d\'une livraison en magasin?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550962-colissimo-dpd-quels-sont-les-delais-et-modalites-d-une-livraison',
      label: 'Colissimo/DPD : quels sont les délais et modalités de livraison ?'
    }, {
      url: 'http://faq-lux.maisonsdumonde.com/articles/2551290-puis-je-echanger-en-magasin-un-meuble-commande-sur-internet',
      label: 'Puis-je échanger en magasin un article commandé sur internet ?'
    }],
    GIFTS: [{
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550179-je-souhaite-offrir-une-carte-cadeau',
      label: 'Je souhaite offrir une carte cadeau.'
    }, {
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550153-comment-utiliser-ma-carte-cadeau',
      label: 'Comment utliser ma carte cadeau '
    }],
    PROFILE: [{
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550130-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles',
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles?'
    }, {
      url: 'http://faq-lux.maisonsdumonde.com/articles/2550393-je-n-ai-pas-recu-mon-e-mail-de-confirmation-ou-d-expedition-de-commande',
      label: 'Je n\'ai pas reçu mon e-mail de confirmation ou d\'expédition de commande.'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-lux.maisonsdumonde.com/fr/collections/1474490-livraison'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-lux.maisonsdumonde.com/fr/collections/1474490-livraison'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-lux.maisonsdumonde.com/fr/collections/1474490-livraison'
    }]
  }
}, {
  language: 'en-GB',
  questions: {
    HOTTOPICS: [{
      url: 'https://help-uk.maisonsdumonde.com/en/collections/1223095-delivery',
      label: 'Delivery'
    }, {
      url: 'https://help-uk.maisonsdumonde.com/en/collections/1223125-refunds-returns',
      label: 'Refunds & returns'
    }, {
      url: 'https://help-uk.maisonsdumonde.com/en/collections/1223108-products-availability',
      label: 'Products & availability'
    }],
    HOME: [{
      url: 'http://help-uk.maisonsdumonde.com/articles/2281868-what-are-the-delivery-costs',
      label: 'What are the delivery costs?'
    }, {
      url: 'https://help-uk.maisonsdumonde.com/articles/2281872-what-are-the-delivery-regions-for-maisons-du-monde',
      label: 'What are the delivery regions for Maisons du Monde?'
    }],
    ORDERS: [{
      url: 'http://help-uk.maisonsdumonde.com/articles/2346448-how-and-when-am-i-refunded',
      label: 'How and when am I refunded?'
    }, {
      url: 'http://help-uk.maisonsdumonde.com/articles/2346435-will-delivery-fees-be-refunded',
      label: 'Will delivery fees be refunded?'
    }],
    ORDERDETAILS: [{
      url: 'http://help-uk.maisonsdumonde.com/articles/2283861-i-want-to-return-a-product-that-i-ordered-online',
      label: 'I want to return a product that I ordered online?'
    }, {
      url: 'http://help-uk.maisonsdumonde.com/articles/2282778-dhl-what-are-the-times-and-terms-of-delivery',
      label: 'DHL : what are the times and terms of delivery ?'
    }],
    GIFTS: [{
      url: 'http://help-uk.maisonsdumonde.com/articles/2281394-how-do-i-use-my-voucher',
      label: 'How do I use my voucher?'
    }, {
      url: 'http://help-uk.maisonsdumonde.com/articles/2281410-i-have-not-received-my-voucher-that-was-sent-by-email-or-post',
      label: 'I have not received my voucher that was sent by email or post.'
    }],
    PROFILE: [{
      url: 'http://help-uk.maisonsdumonde.com/articles/2282729-how-can-i-exercise-my-rights-for-my-personal-data',
      label: 'How can I exercise my rights for my personal data?'
    }, {
      url: 'http://help-uk.maisonsdumonde.com/articles/2281784-i-want-to-change-my-delivery-address',
      label: 'I want to change my delivery address'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://help-uk.maisonsdumonde.com/en/collections/1223095-delivery'
    }],
    OTHERQUESTION: [{
      url: 'https://help-uk.maisonsdumonde.com/en/collections/1223095-delivery'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://help-uk.maisonsdumonde.com/en/collections/1223095-delivery'
    }]
  }
}, {
  language: 'fr-BE',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1407218-livraison',
      label: 'Livraison'
    }, {
      url: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1410739-retour-et-remboursement',
      label: 'Retour et remboursement'
    }, {
      url: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1400253-produits-et-disponibilite',
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2443592-quel-est-le-montant-des-frais-de-livraison',
      label: 'Quel est le montant des frais de livraison ?'
    }, {
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2443533-est-il-possible-de-me-faire-livrer-en-magasin',
      label: 'Est-il possible de me faire livrer en magasin?'
    }],
    ORDERS: [{
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2443786-quels-sont-les-delais-et-modes-de-remboursement',
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2443602-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin',
      label: 'Quels sont les délais et modalités d\'une livraison en magaisn?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2443613-colissimo-quels-sont-les-delais-et-modalites-d-une-livraison',
      label: 'Colissimo : quels sont les délais et modalités d\'une livraison ?'
    }, {
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2791350-ab-custom-quels-sont-les-delais-et-modalites-d-une-livraison',
      label: 'Ab Custom : quels sont les délais et modalités d\'une livraison ?'
    }],
    GIFTS: [{
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2442769-je-souhaite-offrir-une-carte-cadeau',
      label: 'Je souhaite offrir une carte cadeau?'
    }, {
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2440862-comment-utiliser-ma-carte-cadeau',
      label: 'Comment utiliser ma carte cadeau ?'
    }],
    PROFILE: [{
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2443344-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles',
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles ?'
    }, {
      url: 'http://faq-belgique.maisonsdumonde.com/articles/2417847-je-n-ai-pas-recu-mon-e-mail-de-confirmation-ou-d-expedition-de-commande',
      label: 'Je n\'ai pas reçu mon e-mail de confirmation ou d\'expédition de commande.'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1407218-livraison'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1407218-livraison'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-belgique.maisonsdumonde.com/fr/collections/1407218-livraison'
    }]
  }
}, {
  language: 'nl-BE',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1464304-levering',
      label: 'Levering'
    }, {
      url: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1464319-retourneren-en-terugbetaling',
      label: 'Retourneren en terugbetaling'
    }, {
      url: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1407212-producten-en-verkrijgbaarheid',
      label: 'Producten en verkrijgbaarheid'
    }],
    HOME: [{
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2535827-kan-ik-mijn-bestelling-in-de-winkel-laten-bezorgen',
      label: 'Kan ik mijn bestelling in de winkel laten bezorgen?'
    }, {
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2535851-welke-transporteur-zal-mijn-bestelling-leveren',
      label: 'Welke transporteur zal mijn bestelling leveren?'
    }],
    ORDERS: [{
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2535828-wat-zijn-de-leveringstermijnen-en-voorwaarden-in-de-winkel',
      label: 'Wat zijn de leveringstermijnen en -voorwaarden in de winkel?'
    }, {
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2536019-wat-zijn-de-termijnen-en-methoden-voor-terugbetalingen',
      label: 'Wat zijn de termijnen en methoden voor terugbetalingen?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2535835-chronopost-dpd-wat-zijn-de-leveringstermijnen-en-voorwaarden',
      label: 'Chronopost / DPD: wat zijn de leveringstermijnen en -voorwaarden?'
    }, {
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2535845-colissimo-bpost-wat-zijn-de-leveringstermijnen-en-voorwaarden',
      label: 'Colissimo / Bpost: wat zijn de leveringstermijnen en -voorwaarden?'
    }],
    GIFTS: [{
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2535656-hoe-kan-ik-mijn-cadeaubon-gebruiken',
      label: 'Hoe kan ik mijn cadeaubon gebruiken?'
    }, {
      url: 'https://app.intercom.io/a/apps/heeerdnj/articles/articles/2535681/show',
      label: 'Ik kan mijn cadeaubon niet gebruiken.'
    }],
    PROFILE: [{
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2532980-hoe-kan-ik-mijn-rechten-uitoefenen-om-mijn-persoonlijke-gegevens-te-beschermen',
      label: 'Hoe kan ik mijn rechten uitoefenen om mijn persoonlijke gegevens te beschermen?'
    }, {
      url: 'http://faq-belgie.maisonsdumonde.com/articles/2533102-ik-heb-geen-bevestigingsmail-of-verzendbevestiging-ontvangen',
      label: 'Ik heb geen bevestigingsmail of verzendbevestiging ontvangen.'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1464304-levering'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1464304-levering'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-belgie.maisonsdumonde.com/nl/collections/1464304-levering'
    }]
  }
}, {
  language: 'nl-NL',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1469850-levering',
      label: 'Levering'
    }, {
      url: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1469867-retourneren-en-terugbetaling',
      label: 'Retourneren en terugbetaling'
    }, {
      url: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1410533-producten-en-verkrijgbaarheid',
      label: 'Producten en verkrijgbaarheid'
    }],
    HOME: [{
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2543838-hoeveel-bedragen-de-verzendkosten',
      label: 'Hoeveel bedragen de verzendkosten?'
    }, {
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2543877-welke-transporteur-zal-mijn-bestelling-leveren',
      label: 'Welke transporteur zal mijn bestelling leveren?'
    }],
    ORDERS: [{
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2544055-wat-zijn-de-termijnen-en-methoden-voor-terugbetalingen',
      label: 'Wat zijn de termijnen en methoden voor terugbetalingen?'
    }, {
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2544045-worden-mijn-verzendkosten-terugbetaald',
      label: 'Worden mijn verzendkosten terugbetaald?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2543863-chronopost-dpd-wat-zijn-de-leveringstermijnen-en-voorwaarden',
      label: 'Chronopost/DPD: wat zijn de leveringstermijnen en -voorwaarden?'
    }, {
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2543999-ik-wil-mijn-pakket-retourneren-en-de-terugbetalingsvoorwaarden-kennen',
      label: 'Ik wil mijn pakket retourneren en de terugbetalingsvoorwaarden kennen.'
    }],
    GIFTS: [{
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2541610-hoe-kan-ik-mijn-cadeaubon-gebruiken',
      label: 'Hoe kan ik mijn cadeaubon gebruiken?'
    }, {
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2541706-hoe-kan-ik-mijn-aankoopbon-gebruiken',
      label: 'Hoe kan ik mijn aankoopbon gebruiken?'
    }],
    PROFILE: [{
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2541589-hoe-kan-ik-mijn-rechten-uitoefenen-om-mijn-persoonlijke-gegevens-te-beschermen',
      label: 'Hoe kan ik mijn rechten uitoefenen om mijn persoonlijke gegevens te beschermen?'
    }, {
      url: 'http://faq-nederland.maisonsdumonde.com/articles/2541840-ik-heb-geen-bevestigingsmail-of-verzendbevestiging-ontvangen',
      label: 'Ik heb geen bevestigingsmail of verzendbevestiging ontvangen.'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1469850-levering'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1469850-levering'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-nederland.maisonsdumonde.com/nl/collections/1469850-levering'
    }]
  }
}, {
  language: 'de-DE',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1462565-lieferung',
      label: 'Lieferung'
    }, {
      url: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1462573-retouren-und-erstattungen',
      label: 'Retouren und Erstattungen'
    }, {
      url: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1410537-artikel-und-verfugbarkeit',
      label: 'Artikel und Verfügbarkeit'
    }],
    HOME: [{
      url: ' http://faq-deutschland.maisonsdumonde.com/articles/2532705-wie-hoch-sind-die-lieferkosten',
      label: 'Wie hoch sind die Lieferkosten?'
    }, {
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2532781-welcher-spediteur-wird-mich-beliefern',
      label: 'Welcher Spediteur wird mich beliefern?'
    }],
    ORDERS: [{
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2530996-welche-fristen-und-bedingungen-gelten-fur-die-erstattung',
      label: 'Welche Fristen und Bedingungen gelten für die Erstattung?'
    }, {
      url: ' http://faq-deutschland.maisonsdumonde.com/articles/2530979-werden-meine-lieferkosten-erstattet',
      label: 'Werden meine Lieferkosten erstattet?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2532741-colissimo-dpd-welche-lieferzeit-und-bedingungen-gelten-fur-die-lieferung',
      label: 'Colissimo/DPD : welche Fristen und Bedingungen gelten für die Lieferung?'
    }, {
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2532768-dhl-welche-lieferzeit-und-bedingungen-gelten-fur-die-lieferung',
      label: 'DHL: welche Fristen und Bedingungen gelten für die Lieferung?'
    }],
    GIFTS: [{
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2530415-wie-kann-ich-meinen-gutschein-einlosen',
      label: 'Wie kann ich meinen Gutschein einlösen?'
    }, {
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2530178-wie-kann-ich-meine-geschenkkarte-einlosen',
      label: 'Wie kann ich meine Geschenkkarte einlösen?'
    }],
    PROFILE: [{
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2529806-wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben',
      label: 'Wie kann ich meine Rechte bezüglich des Schutzes meiner personenbezogenen Daten ausüben?'
    }, {
      url: 'http://faq-deutschland.maisonsdumonde.com/articles/2529847-ich-habe-mein-passwort-vergessen-was-kann-ich-tun',
      label: 'Ich habe mein Passwort vergessen, was kann ich tun?'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1462565-lieferung'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1462565-lieferung'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-deutschland.maisonsdumonde.com/de/collections/1462565-lieferung'
    }]
  }
}, {
  language: 'de-AT',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1471417-lieferung',
      label: 'Lieferung'
    }, {
      url: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1471424-retouren-und-erstattungen',
      label: 'Retouren und Erstattungen'
    }, {
      url: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1410541-artikel-und-verfugbarkeit',
      label: 'Artikel und Verfügbarkeit'
    }],
    HOME: [{
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2544751-wie-hoch-sind-die-lieferkosten',
      label: 'Wie hoch sind die Lieferkosten?'
    }, {
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2544755-wohin-liefert-maisons-du-monde',
      label: 'Wohin liefert Maisons du Monde?'
    }],
    ORDERS: [{
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2544781-welcher-spediteur-wird-mich-beliefern',
      label: 'Welcher Spediteur wird mich beliefern?'
    }, {
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2546837-welche-fristen-und-bedingungen-gelten-fur-die-erstattung',
      label: 'Welche Fristen und Bedingungen gelten für die Erstattung??'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2546850-ich-mochte-mein-paket-zuruckschicken-und-mich-uber-die-erstattungsbedingungen-informieren',
      label: 'Ich möchte mein Paket zurückschicken und mich über die Erstattungsbedingungen informieren.'
    }, {
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2544773-colissimo-dpd-welche-fristen-und-bedingungen-gelten-fur-die-lieferung',
      label: 'Colissimo: welche Fristen und Bedingungen gelten für die Lieferung?'
    }],
    GIFTS: [{
      url: 'https://app.intercom.io/a/apps/sb9q4ncy/articles/articles/2544426/show',
      label: 'Wie kann ich meinen Gutschein einlösen?'
    }, {
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2544386-wie-kann-ich-meine-geschenkkarte-einlosen',
      label: 'Wie kann ich meine Geschenkkarte einlösen?'
    }],
    PROFILE: [{
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2544332-wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben',
      label: 'Wie kann ich meine Rechte bezüglich des Schutzes meiner personenbezogenen Daten ausüben?'
    }, {
      url: 'http://faq-oesterreich.maisonsdumonde.com/articles/2544346-ich-habe-mein-passwort-vergessen-was-kann-ich-tun',
      label: 'Ich habe mein Passwort vergessen, was kann ich tun?'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1471417-lieferung'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1471417-lieferung'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-oesterreich.maisonsdumonde.com/de/collections/1471417-lieferung'
    }]
  }
}, {
  language: 'it-CH',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1460829-consegna',
      label: 'Consegna'
    }, {
      url: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1460838-resi-e-rimborsi',
      label: 'Resi e rimborsi'
    }, {
      url: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1410546-prodotti-e-disponibilita',
      label: 'Prodotti e disponibilità'
    }],
    HOME: [{
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2527718-quali-sono-i-costi-di-spedizione',
      label: 'Quali sono i costi di spedizione'
    }, {
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2527836-quale-corriere-consegnera-il-mio-ordine',
      label: 'Quale corriere consegnerà il moi ordine'
    }],
    ORDERS: [{
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2527145-come-posso-seguire-il-mio-ordine',
      label: 'Come posso seguire il mio ordine?'
    }, {
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2529606-quali-sono-i-tempi-e-le-modalita-di-rimborso',
      label: 'Quali sono i tempi e le modalità di rimborso?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2527825-chronopost-quali-sono-i-tempi-e-le-modalita-di-consegna',
      label: 'Chronopost: quali sono i tempi e le modalità di consegna?'
    }, {
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2527789-geodis-mlp-quali-sono-i-tempi-e-le-modalita-di-consegna',
      label: 'Geodis MLP : quali sono i tempi e le modalità di consegna?'
    }],
    GIFTS: [{
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2526929-c-e-una-carta-fedelta-maisons-du-monde',
      label: 'C\'è una carta di fedeltà Maisons du Monde?'
    }, {
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2526470-come-uso-il-mio-buono-acquisto',
      label: 'Come uso il moi buono acquisto '
    }],
    PROFILE: [{
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2526926-come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali',
      label: 'Come posso esercitare i miei diritti nella protezione dei miei dati personali?'
    }, {
      url: 'http://faq-svizzera.maisonsdumonde.com/articles/2527138-non-ho-ricevuto-l-email-di-conferma-o-di-spedizione-dell-ordine',
      label: 'Non ho ricevuto l\'email di conferma o di spedizione dell\'ordine'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1460829-consegna'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1460829-consegna'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-svizzera.maisonsdumonde.com/it/collections/1460829-consegna'
    }]
  }
}, {
  language: 'fr-CH',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1413246-livraison',
      label: 'Livraison'
    }, {
      url: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1413252-retour-et-remboursement',
      label: 'Retour et remboursement'
    }, {
      url: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1410548-produits-et-disponibilite',
      label: 'Produit et disponibilité'
    }],
    HOME: [{
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446688-quel-est-le-montant-des-frais-de-livraison',
      label: 'Quel est le montant des frais de livraison ?'
    }, {
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446711-quel-transporteur-va-me-livrer',
      label: 'Quel transporteur va me livrer ?'
    }],
    ORDERS: [{
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446788-quels-sont-les-delais-et-modes-de-remboursement',
      label: 'Quels sont les délais et modes de remboursement ?'
    }, {
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446615-est-il-possible-de-me-faire-livrer-en-magasin',
      label: 'Est-il possible de me faire livrer en magasin?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2541099-chronopost-dpd-quels-sont-les-delais-et-modalites-d-une-livraison',
      label: 'Chronopost / DPD : quels sont les délais et modalités d\'une livraison ?'
    }, {
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446694-geodis-mlp-quels-sont-les-delais-et-modalites-d-une-livraison',
      label: 'Geodis MLP : quels sont les délais et modalités d\'une livraison ?'
    }],
    GIFTS: [{
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446560-je-souhaite-offrir-une-carte-cadeau',
      label: 'Je souhaite offrir une carte cadeau.'
    }, {
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446306-comment-consulter-le-solde-de-mon-avoir',
      label: 'Comment consulter le solde de mon avoir ?'
    }],
    PROFILE: [{
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2446155-comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles',
      label: 'Comment puis-je exercer mes droits en matière de protection de mes données personnelles ?'
    }, {
      url: 'http://faq-suisse.maisonsdumonde.com/articles/2440463-je-n-ai-pas-recu-mon-e-mail-de-confirmation-ou-d-expedition-de-commande',
      label: 'Je n\'ai pas reçu mon e-mail de confirmation ou d\'expédition de commande.'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1413246-livraison'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1413246-livraison'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-suisse.maisonsdumonde.com/fr/collections/1413246-livraison'
    }]
  }
}, {
  language: 'de-CH',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1466189-lieferung',
      label: 'Lieferung'
    }, {
      url: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1466199-retouren-und-erstattungen',
      label: 'Retouren und Erstattungen'
    }, {
      url: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1410543-artikel-und-verfugbarkeit',
      label: 'Artikel und Verfügbarkeit'
    }],
    HOME: [{
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2536581-wie-hoch-sind-die-lieferkosten',
      label: 'Wie hoch sind die Lieferkosten?'
    }, {
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2536652-welcher-spediteur-wird-mich-beliefern',
      label: 'Welcher Spediteur wird mich beliefern?'
    }],
    ORDERS: [{
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2540962-welche-fristen-und-bedingungen-gelten-fur-die-erstattung',
      label: 'Welche Fristen und Bedingungen gelten für die Erstattung?'
    }, {
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2536840-werden-meine-lieferkosten-erstattet',
      label: 'Werden meine Lieferkosten erstattet?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2536628-geodis-mlp-welche-fristen-und-bedingungen-gelten-fur-die-lieferung',
      label: 'Geodis MLP: welche Fristen und Bedingungen gelten für die Lieferung?'
    }, {
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2540961-kann-ich-ein-im-internet-bestelltes-mobel-in-einer-filiale-umtauschen',
      label: 'Kann ich im Internet bestellte Möbel in einer Filiale umtauschen?'
    }],
    GIFTS: [{
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2540758-wie-kann-ich-meinen-gutschein-einlosen',
      label: 'Wie kann ich meinen Gutschein einlösen?'
    }, {
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2540761-wie-kann-ich-meine-geschenkkarte-einlosen',
      label: 'Wie kann ich meine Geschenkkarte einlösen?'
    }],
    PROFILE: [{
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2536368-wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben',
      label: 'Wie kann ich meine Rechte bezüglich des Schutzes meiner personenbezogenen Daten ausüben?'
    }, {
      url: 'http://faq-schweiz.maisonsdumonde.com/articles/2536381-ich-habe-mein-passwort-vergessen-was-kann-ich-tun',
      label: 'Ich habe mein Passwort vergessen, was kann ich tun?'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1466189-lieferung'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1466189-lieferung'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-schweiz.maisonsdumonde.com/de/collections/1466189-lieferung'
    }]
  }
}, {
  language: 'es-ES',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-es.maisonsdumonde.com/es/collections/1440575-envio',
      label: 'Envío'
    }, {
      url: 'https://faq-es.maisonsdumonde.com/es/collections/1440576-devolucion-y-reembolso',
      label: 'Devolución y reembolso'
    }, {
      url: 'https://faq-es.maisonsdumonde.com/es/collections/1410550-productos-y-disponibilidad',
      label: 'Productos y disponibilidad'
    }],
    HOME: [{
      url: 'http://faq-es.maisonsdumonde.com/articles/2495375-cual-es-el-importe-de-los-gastos-de-envio',
      label: '¿Cuál es el importe de los gastos de envío?'
    }, {
      url: 'http://faq-es.maisonsdumonde.com/articles/2495618-que-transportista-realizara-mi-entrega',
      label: '¿Qué transportista realizará mi entrega?'
    }],
    ORDERS: [{
      url: 'http://faq-es.maisonsdumonde.com/articles/2498188-cuales-son-los-plazos-y-modos-de-reembolso',
      label: '¿Cuáles son los plazos y modos de reembolso?'
    }, {
      url: 'http://faq-es.maisonsdumonde.com/articles/2496177-me-reembolsareis-los-gastos-de-envio',
      label: '¿Me reembolsaréis los gastos de envío?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-es.maisonsdumonde.com/articles/2495595-ab-custom-cuales-son-los-plazos-y-modalidades-de-entrega',
      label: 'Ab Custom: ¿cuáles son los plazos y modalidades de entrega?'
    }, {
      url: 'http://faq-es.maisonsdumonde.com/articles/2881170-puedo-devolver-un-articulo-pedido-desde-la-pagina-web-en-tienda',
      label: '¿Puedo devolver un artículo pedido desde la página web en tienda?'
    }],
    GIFTS: [{
      url: 'http://faq-es.maisonsdumonde.com/articles/2494662-existe-una-tarjeta-de-fidelidad-maisons-du-monde',
      label: '¿Existe una tarjeta de fidelidad Maisons du Monde?'
    }, {
      url: 'http://faq-es.maisonsdumonde.com/articles/2495645-he-comprado-una-tarjeta-regalo-por-internet-y-necesito-una-factura',
      label: 'He comprado una tarjeta regalo por internet y necesito una factura.'
    }],
    PROFILE: [{
      url: 'http://faq-es.maisonsdumonde.com/articles/2492541-como-puedo-ejercer-mis-derechos-en-materia-de-proteccion-de-mis-datos-personales',
      label: '¿Cómo puedo ejercer mis derechos en materia de protección de mis datos personales?'
    }, {
      url: 'http://faq-es.maisonsdumonde.com/articles/2494787-deseo-modificar-mi-direccion-de-facturacion',
      label: 'Deseo modificar mi dirección de factura'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-es.maisonsdumonde.com/es/collections/1440575-envio'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-es.maisonsdumonde.com/es/collections/1440575-envio'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-es.maisonsdumonde.com/es/collections/1440575-envio'
    }]
  }
}, {
  language: 'it-IT',
  questions: {
    HOTTOPICS: [{
      url: 'https://faq-italia.maisonsdumonde.com/it/collections/1432865-consegna',
      label: 'Consegna'
    }, {
      url: 'https://faq-italia.maisonsdumonde.com/it/collections/1433177-resi-e-rimborsi',
      label: 'Resi e rimborsi'
    }, {
      url: 'https://faq-italia.maisonsdumonde.com/it/collections/1432899-prodotti-e-disponibilita',
      label: 'Prodotti e disponibilità'
    }],
    HOME: [{
      url: 'http://faq-italia.maisonsdumonde.com/articles/2479818-quali-sono-i-costi-di-spedizione',
      label: 'Quali sono i costi di spedizione?'
    }, {
      url: 'http://faq-italia.maisonsdumonde.com/articles/2479719-quale-corriere-consegnera-il-mio-ordine',
      label: 'Quale corriere consegnerà il moi ordine '
    }],
    ORDERS: [{
      url: 'http://faq-italia.maisonsdumonde.com/articles/2480595-quali-sono-i-tempi-e-le-modalita-di-rimborso',
      label: 'Quali sono i tempi e le modalità di rimborso?'
    }, {
      url: 'http://faq-italia.maisonsdumonde.com/articles/2480587-posso-sostituire-in-negozio-un-mobile-ordinato-su-internet',
      label: 'Posso sostituire in negozio un mobile ordinato su Internet?'
    }],
    ORDERDETAILS: [{
      url: 'http://faq-italia.maisonsdumonde.com/articles/2480049-colissimo-quali-sono-i-tempi-e-le-modalita-di-consegna',
      label: 'Colissimo: quali sono i tempi e le modalità di consegna?'
    }, {
      url: 'http://faq-italia.maisonsdumonde.com/articles/2480063-dhl-quali-sono-i-tempi-e-le-modalita-di-consegna',
      label: 'DHL: quali sono i tempi e le modalità di consegna?'
    }],
    GIFTS: [{
      url: 'http://faq-italia.maisonsdumonde.com/articles/2479705-vorrei-offrire-una-carta-regalo',
      label: 'Vorrei offrire una carta regalo.'
    }, {
      url: 'http://faq-italia.maisonsdumonde.com/articles/2479682-c-e-una-carta-fedelta-maisons-du-monde',
      label: 'C\'è una carta fedeltà Maisons du Monde?'
    }],
    PROFILE: [{
      url: 'http://faq-italia.maisonsdumonde.com/articles/2479779-come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali',
      label: 'Come posso esercitare i miei diritti nella protezione dei miei dati personali?'
    }, {
      url: 'http://faq-italia.maisonsdumonde.com/articles/2479807-voglio-cambiare-il-mio-indirizzo-di-consegna',
      label: 'Voglio cambiare il mio indirizzo di consegna '
    }],
    SHIPPINGDETAILS: [{
      url: 'https://faq-italia.maisonsdumonde.com/it/collections/1432865-consegna'
    }],
    OTHERQUESTION: [{
      url: 'https://faq-italia.maisonsdumonde.com/it/collections/1432865-consegna'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://faq-italia.maisonsdumonde.com/it/collections/1432865-consegna'
    }]
  }
}, {
  language: 'pt-PT',
  questions: {
    HOTTOPICS: [{
      url: 'https://help-pt.maisonsdumonde.com/pt/collections/1472882-envio',
      label: 'Envio'
    }, {
      url: 'https://help-pt.maisonsdumonde.com/pt/collections/1472887-devolucao-e-reembolso',
      label: 'Devolução e reembolso'
    }, {
      url: 'https://help-pt.maisonsdumonde.com/pt/collections/1410568-produtos-e-disponibilidade',
      label: 'Produtos e disponibilidade'
    }],
    HOME: [{
      url: 'http://help-pt.maisonsdumonde.com/articles/2547530-how-much-is-the-cost-of-delivery',
      label: 'How much is the cost of delivery?'
    }, {
      url: 'http://help-pt.maisonsdumonde.com/articles/2547533-what-is-maison-du-monde-s-delivery-area',
      label: 'What is Maisons du Monde\'s delivery area?'
    }],
    ORDERS: [{
      url: 'http://help-pt.maisonsdumonde.com/articles/2547549-what-courier-do-you-use-for-delivery',
      label: 'What courier do you use for delivery?'
    }, {
      url: 'http://help-pt.maisonsdumonde.com/articles/2547866-what-is-the-procedure-for-a-refund-and-how-long-does-it-take',
      label: 'What is the procedure for a refund and how long does it take?'
    }],
    ORDERDETAILS: [{
      url: 'http://help-pt.maisonsdumonde.com/articles/2547544-chronopost-what-are-the-delivery-times-and-procedures',
      label: 'Chronopost: what are the delivery times and procedures?'
    }, {
      url: 'http://help-pt.maisonsdumonde.com/articles/2547541-colissimo-what-are-the-delivery-times-and-procedures',
      label: 'Colissimo: what are the delivery times and procedures?'
    }],
    GIFTS: [{
      url: 'http://help-pt.maisonsdumonde.com/articles/2547623-how-do-i-use-my-voucher',
      label: 'How do I use my voucher?'
    }, {
      url: ' http://help-pt.maisonsdumonde.com/articles/2553876-how-do-i-use-my-gift-card',
      label: 'How do I use my gift card?'
    }],
    PROFILE: [{
      url: 'http://help-pt.maisonsdumonde.com/articles/2547463-i-would-like-to-change-my-delivery-address',
      label: 'I would like to change my delivery address'
    }, {
      url: 'http://help-pt.maisonsdumonde.com/articles/2547214-how-do-i-exercise-my-rights-in-relation-to-my-personal-data',
      label: 'How do I excercise my rights in relation to my personnal data?'
    }],
    SHIPPINGDETAILS: [{
      url: 'https://help-pt.maisonsdumonde.com/pt/collections/1472882-envio'
    }],
    OTHERQUESTION: [{
      url: 'https://help-pt.maisonsdumonde.com/pt/collections/1472882-envio'
    }],
    EXCHANGEPRODUCT: [{
      url: 'https://help-pt.maisonsdumonde.com/pt/collections/1472882-envio'
    }]
  }
}];
var MODULE_FAQ_V2 = [{
  title: 'frequently-asked-questions-01',
  questions: [{
    // a rollback après confinement
    language: 'fr-FR',
    label: 'Est-ce que vos magasins restent ouverts ?',
    url: 'https://faq-france.maisonsdumonde.com/fr/articles/3808596-est-ce-que-vos-magasins-restent-ouverts'
  }, {
    language: 'fr-BE',
    label: 'Quels sont les délais et modalités d’une livraison en magasin ?',
    url: 'https://faq-belgique.maisonsdumonde.com/fr/articles/2443602-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin'
  }, {
    language: 'fr-LU',
    label: 'Quels sont les délais et modalités d’une livraison en magasin ?',
    url: 'https://faq-lux.maisonsdumonde.com/fr/articles/2550950-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin'
  }, {
    language: 'fr-CH',
    label: 'Quels sont les délais et modalités d’une livraison en magasin ?',
    url: 'https://faq-suisse.maisonsdumonde.com/fr/articles/2446692-quels-sont-les-delais-et-modalites-d-une-livraison-en-magasin'
  }, {
    language: 'it-IT',
    label: 'Quali sono i costi di spedizione?',
    url: 'http://faq-italia.maisonsdumonde.com/articles/2479818-quali-sono-i-costi-di-spedizione'
  }, {
    language: 'it-CH',
    label: 'Quali sono i costi di spedizione?',
    url: 'https://faq-svizzera.maisonsdumonde.com/it/articles/2527718-quali-sono-i-costi-di-spedizione'
  }, {
    language: 'es-ES',
    label: '¿Cuáles son los plazos y modos de reembolso?',
    url: 'http://faq-es.maisonsdumonde.com/articles/2498188-cuales-son-los-plazos-y-modos-de-reembolso'
  }, {
    language: 'de-DE',
    label: 'Welche Fristen und Bedingungen gelten für die Erstattung?',
    url: 'http://faq-deutschland.maisonsdumonde.com/articles/2530996-welche-fristen-und-bedingungen-gelten-fur-die-erstattung'
  }, {
    language: 'de-CH',
    label: 'Welche Fristen und Bedingungen gelten für die Erstattung?',
    url: 'https://faq-schweiz.maisonsdumonde.com/de/articles/4231145-welche-fristen-und-bedingungen-gelten-fur-die-erstattung'
  }, {
    language: 'de-AT',
    label: 'Welche Fristen und Bedingungen gelten für die Erstattung?',
    url: 'https://faq-oesterreich.maisonsdumonde.com/de/articles/2546837-welche-fristen-und-bedingungen-gelten-fur-die-erstattung'
  }, {
    language: 'en-GB',
    label: 'I want to return a product that I ordered online?',
    url: 'https://help-uk.maisonsdumonde.com/en/articles/2283861-i-want-to-return-a-product-that-i-ordered-online'
  }, {
    language: 'pt-PT',
    label: 'Qual é o valor dos portes de envio?',
    url: 'https://help-pt.maisonsdumonde.com/pt/articles/2547530-qual-e-o-valor-dos-portes-de-envio'
  }, {
    language: 'nl-NL',
    label: 'Hoeveel bedragen de verzendkosten?',
    url: 'http://faq-nederland.maisonsdumonde.com/articles/2543838-hoeveel-bedragen-de-verzendkosten'
  }, {
    language: 'nl-BE',
    label: 'Hoeveel bedragen de verzendkosten?',
    url: 'https://faq-belgie.maisonsdumonde.com/nl/articles/2535808-hoeveel-bedragen-de-verzendkosten'
  }]
}, {
  title: 'frequently-asked-questions-02',
  questions: [{
    // a rollback après confinement
    language: 'fr-FR',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: 'https://faq-france.maisonsdumonde.com/fr/articles/4227954-puis-je-retourner-en-magasin-un-article-commande-sur-internet'
  }, {
    language: 'fr-BE',
    label: 'Quels sont les délais et modes de remboursement ?',
    url: 'https://faq-belgique.maisonsdumonde.com/fr/articles/2443786-quels-sont-les-delais-et-modes-de-remboursement'
  }, {
    language: 'fr-LU',
    label: 'Quels sont les délais et modes de remboursement ?',
    url: 'https://faq-lux.maisonsdumonde.com/fr/articles/2551352-quels-sont-les-delais-et-modes-de-remboursement'
  }, {
    language: 'fr-CH',
    label: 'Quels sont les délais et modes de remboursement ?',
    url: 'https://faq-suisse.maisonsdumonde.com/fr/articles/2446788-quels-sont-les-delais-et-modes-de-remboursement'
  }, {
    language: 'it-IT',
    label: 'Quale corriere consegnera il mio ordine?',
    url: 'http://faq-italia.maisonsdumonde.com/articles/2479719-quale-corriere-consegnera-il-mio-ordine'
  }, {
    language: 'it-CH',
    label: 'Quale corriere consegnera il mio ordine?',
    url: 'https://faq-svizzera.maisonsdumonde.com/it/articles/2527836-quale-corriere-consegnera-il-mio-ordine'
  }, {
    language: 'es-ES',
    label: '¿Cuál es el importe de los gastos de envío?',
    url: 'http://faq-es.maisonsdumonde.com/articles/2495375-cual-es-el-importe-de-los-gastos-de-envio'
  }, {
    language: 'de-DE',
    label: 'Wie hoch sind die Lieferkosten?',
    url: 'http://faq-deutschland.maisonsdumonde.com/articles/2532705-wie-hoch-sind-die-lieferkosten'
  }, {
    language: 'de-CH',
    label: 'Wie hoch sind die Lieferkosten?',
    url: 'https://faq-schweiz.maisonsdumonde.com/de/articles/4231153-wie-hoch-sind-die-lieferkosten'
  }, {
    language: 'de-AT',
    label: 'Wie hoch sind die Lieferkosten?',
    url: 'https://faq-oesterreich.maisonsdumonde.com/de/articles/4231253-wie-hoch-sind-die-lieferkosten'
  }, {
    language: 'en-GB',
    label: 'What are the delivery costs?',
    url: 'http://help-uk.maisonsdumonde.com/articles/2281868-what-are-the-delivery-costs'
  }, {
    language: 'pt-PT',
    label: 'Onde entrega a Maisons du Monde?',
    url: 'https://help-pt.maisonsdumonde.com/pt/articles/2547533-onde-entrega-a-maisons-du-monde'
  }, {
    language: 'nl-NL',
    label: 'Welke transporteur zal mijn bestelling leveren?',
    url: 'http://faq-nederland.maisonsdumonde.com/articles/2543877-welke-transporteur-zal-mijn-bestelling-leveren'
  }, {
    language: 'nl-BE',
    label: 'Welke transporteur zal mijn bestelling leveren?',
    url: 'https://faq-belgie.maisonsdumonde.com/nl/articles/2535851-welke-transporteur-zal-mijn-bestelling-leveren'
  }]
}, {
  title: 'frequently-asked-questions-03',
  questions: [{
    // a rollback après confinement
    language: 'fr-FR',
    label: 'Je n’arrive pas à joindre votre transporteur. Qu’en est-il de ma livraison en cours à domicile et de ma prise de rendez-vous ?',
    url: 'https://faq-france.maisonsdumonde.com/fr/articles/4582672-je-n-arrive-pas-a-joindre-votre-transporteur-qu-en-est-il-de-ma-livraison-en-cours-a-domicile-et-de-ma-prise-de-rendez-vous'
  }, {
    language: 'fr-BE',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: 'https://faq-belgique.maisonsdumonde.com/fr/articles/2875389-puis-je-retourner-en-magasin-un-article-commande-sur-internet'
  }, {
    language: 'fr-LU',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: 'https://faq-lux.maisonsdumonde.com/fr/articles/2875395-puis-je-retourner-en-magasin-un-article-commande-sur-internet'
  }, {
    language: 'fr-CH',
    label: 'Puis-je retourner en magasin un article commandé sur internet ?',
    url: 'https://faq-suisse.maisonsdumonde.com/fr/articles/2875394-puis-je-retourner-en-magasin-un-article-commande-sur-internet'
  }, {
    language: 'it-IT',
    label: 'Quali sono i tempi e le modalita di rimborso?',
    url: 'http://faq-italia.maisonsdumonde.com/it/articles/2480595-quali-sono-i-tempi-e-le-modalita-di-rimborso'
  }, {
    language: 'it-CH',
    label: 'Quali sono i tempi e le modalita di rimborso?',
    url: 'https://faq-svizzera.maisonsdumonde.com/it/articles/4230872-quali-sono-i-tempi-e-le-modalita-di-rimborso'
  }, {
    language: 'es-ES',
    label: '¿Puedo devolver un artículo pedido desde la página web en tienda?',
    url: 'http://faq-es.maisonsdumonde.com/es/articles/2881170-puedo-devolver-un-articulo-pedido-desde-la-pagina-web-en-tienda'
  }, {
    language: 'de-DE',
    label: 'Welcher Spediteur wird mich beliefern?',
    url: 'http://faq-deutschland.maisonsdumonde.com/articles/2532781-welcher-spediteur-wird-mich-beliefern'
  }, {
    language: 'de-CH',
    label: 'Welcher Spediteur wird mich beliefern?',
    url: 'https://faq-schweiz.maisonsdumonde.com/de/articles/2536652-welcher-spediteur-wird-mich-beliefern'
  }, {
    language: 'de-AT',
    label: 'Welcher Spediteur wird mich beliefern?',
    url: 'https://faq-oesterreich.maisonsdumonde.com/de/articles/4231270-welcher-spediteur-wird-mich-beliefern'
  }, {
    language: 'en-GB',
    label: 'What are the delivery regions for Maisons du Monde?',
    url: 'http://help-uk.maisonsdumonde.com/en/articles/2281872-what-are-the-delivery-regions-for-maisons-du-monde'
  }, {
    language: 'pt-PT',
    label: 'Que empresa de transporte se encarregará da minha entrega?',
    url: 'https://help-pt.maisonsdumonde.com/pt/articles/2547549-que-empresa-de-transporte-se-encarregara-da-minha-entrega'
  }, {
    language: 'nl-NL',
    label: 'Ik wil mijn pakket retourneren en de terugbetalingsvoorwaarden kennen.',
    url: 'http://faq-nederland.maisonsdumonde.com/nl/articles/2543999-ik-wil-mijn-pakket-retourneren-en-de-terugbetalingsvoorwaarden-kennen'
  }, {
    language: 'nl-BE',
    label: 'Ik wil mijn pakket retourneren en de terugbetalingsvoorwaarden kennen.',
    url: 'https://faq-belgie.maisonsdumonde.com/nl/articles/2535964-heeft-u-online-een-bestelling-geplaatst-en-werd-deze-bij-u-thuis-of-in-een-afhaalpunt-afgeleverd'
  }]
}];
export var getQuestionsByLanguage = function getQuestionsByLanguage(id, lang) {
  return MODULE_FAQ_V2.find(function (e) {
    return e.title === id;
  }).questions.find(function (l) {
    return l.language === lang;
  });
};
export var LEGAL_NOTICE = [{
  language: 'fr-FR',
  text: 'MAISONS DU MONDE FRANCE traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu\'un droit à la limitation et à la portabilité de vos données.<a href="https://faq-france.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href="https://www.maisonsdumonde.com/FR/fr/e/legal/securite-et-confidentialite">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>',
  url: '/FR/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'es-ES',
  text: 'MAISONS DU MONDE ESPAÑA SL trata sus datos personales para responder a su solicitud. De Conformidad con el Reglamento(UE) 2016 / 679 del Parlamento Europeo y del Consejo del 27 de abril de 2016 usted dispone de un derecho de acceso, rectificación, limitación u oposición al tratamiento y supresión de sus datos personales, <a href="https://faq-es.maisonsdumonde.com/mi-cuenta-y-datos-personales/como-puedo-ejercer-mis-derechos-en-materia-de-proteccion-de-mis-datos-personales">así como de portabilidad de los mismos, haciendo clic en este enlace.</a> <a href="https://www.maisonsdumonde.com/ES/es/statique/securite-et-confidentialite.htm">Para conocer nuestra Política de Privacidad, visite la sección “Datos Personales” en nuestra página web haciendo clic en este enlace.</a>',
  url: '/ES/es/e/legal/creditos-y-menciones-legales'
}, {
  language: 'it-IT',
  text: 'MAISONS DU MONDE ITALIE S.P.A tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento(UE) 2016 / 679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali. <a href="https://www.maisonsdumonde.com/IT/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy.</a> <a href="https://faq-italia.maisonsdumonde.com/il-mio-account-e-informazioni-personali/come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali">Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci cliccando su questo link.</a>',
  url: '/IT/it/e/legal/crediti-e-menzioni-legali'
}, {
  language: 'de-DE',
  text: 'MAISONS DU MONDE ALLEMAGNE GmbH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. <a href="https://faq-deutschland.maisonsdumonde.com/mein-konto-und-personliche-daten/wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben">Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte klicken Sie bitte hier.</a> <a href="https://www.maisonsdumonde.com/DE/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter</a>',
  url: '/DE/de/e/legal/bildnachweise-und-impressum'
}, {
  language: 'fr-BE',
  text: 'MAISONS DU MONDE BELGIQUE SPRL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu\'un droit à la limitation et à la portabilité de vos données.<a href="https://faq-belgique.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href="https://www.maisonsdumonde.com/BE/fr/statique/securite-et-confidentialite.htm">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>',
  url: '/BE/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'de-AT',
  text: 'MAISONS DU MONDE ÖSTERREICH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. <a href="https://www.maisonsdumonde.com/AT/de/compte2/?action=aide&rub=RD_INFOPERS">Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte klicken Sie bitte hier.</a> <a href="https://www.maisonsdumonde.com/AT/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>',
  url: '/AT/de/e/legal/bildnachweise-und-impressum'
}, {
  language: 'nl-BE',
  text: 'MAISONS DU MONDE BELGIQUE SPRL verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.<a href="https://faq-oesterreich.maisonsdumonde.com/mein-konto-und-personliche-daten/wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben">Bij vragen kunt u klikken op deze link.</a> <a href="https://www.maisonsdumonde.com/BE/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>',
  url: '/BE/nl/e/legal/credits-en-wettelijke-vermeldingen'
}, {
  language: 'de-CH',
  text: 'MAISONS DU MONDE SUISSE SARL nutzt Ihre personenbezogenen Daten, um auf Ihre Anfrage zu antworten. Nach der EU-Verordnung 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 haben Sie das Recht auf Einsichtnahme, Berichtigung, Einschränkung und Löschung der Sie betreffenden Daten. <a href="https://faq-schweiz.maisonsdumonde.com/mein-konto-und-personliche-daten/wie-kann-ich-meine-rechte-bezuglich-des-schutzes-meiner-personenbezogenen-daten-ausuben">Sollten Sie dies wünschen, klicken Sie bitte hier.</a> <a href="https://www.maisonsdumonde.com/CH/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>',
  url: '/CH/de/e/legal/bildnachweise-und-impressum'
}, {
  language: 'fr-CH',
  text: 'MAISONS DU MONDE SUISSE SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement (UE) 2016/679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu\'un droit à la limitation et à la portabilité de vos données. <a href="https://faq-suisse.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href="https://www.maisonsdumonde.com/CH/fr/statique/securite-et-confidentialite.htm">Concernant notre politique de collecte et traitement de vos données personnelles vous la trouverez en cliquant sur ce lien.</a>',
  url: '/CH/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'it-CH',
  text: 'MAISONS DU MONDE SUISSE SARL  tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali. <a href="https://faq-svizzera.maisonsdumonde.com/il-mio-account-e-informazioni-personali/come-posso-esercitare-i-miei-diritti-nella-protezione-dei-miei-dati-personali">Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci cliccando su questo link.</a> <a href="https://www.maisonsdumonde.com/CH/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy.</a>',
  url: '/CH/it/e/legal/crediti-e-menzioni-legali'
}, {
  language: 'fr-LU',
  text: 'MAISONS DU MONDE LUXEMBOURG SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu\'un droit à la limitation et à la portabilité de vos données.<a href="https://faq-lux.maisonsdumonde.com/mon-compte-et-informations-personnelles/comment-puis-je-exercer-mes-droits-en-matiere-de-protection-de-mes-donnees-personnelles">Vous pouvez exercer vos droits en cliquant sur ce lien.</a> <a href="https://www.maisonsdumonde.com/LU/fr/statique/securite-et-confidentialite.htm">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>',
  url: '/LU/fr/e/legal/credits-et-mentions-legales'
}, {
  language: 'nl-NL',
  text: 'MAISONS DU MONDE FRANCE SAS verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.<a href="https://faq-nederland.maisonsdumonde.com/mijn-account-en-persoonlijke-gegevens/hoe-kan-ik-mijn-rechten-uitoefenen-om-mijn-persoonlijke-gegevens-te-beschermen">Bij vragen kunt u klikken op deze link.</a> <a href="https://www.maisonsdumonde.com/NL/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>',
  url: '/NL/nl/e/legal/credits-en-wettelijke-vermeldingen'
}, {
  language: 'pt-PT',
  text: 'MAISONS DU MONDE PORTUGAL recolhe e processa seus dados pessoais a fim de responder ao seu pedido. Em conformidade com o Regulamento(UE) 2016 / 679 do parlamento Europeu e do Conselho, de 27 de abril de 2016, dispõe do direito de acesso, de retificação, de eliminação e de oposição no que diz respeito aos seus dados pessoais, assim como do direito à limitação e à portabilidade dos seus dados. <a href="https://help-pt.maisonsdumonde.com/my-account-and-personal-information/how-do-i-exercise-my-rights-in-relation-to-my-personal-data">Pode também exercer o seu direito por meio da seguinte hiperligação.</a> <a href="https://www.maisonsdumonde.com/PT/pt/statique/securite-et-confidentialite.htm">Para encontrar a nossa política de recolha e de processamento dos seus dados pessoais, clique nesta hiperligação.</a>',
  url: '/PT/pt/e/legal/creditos-e-avisos-legais'
}, {
  language: 'en-GB',
  text: '"MDM UK FURNITURE & DECORATION LIMITED S.L processes your data in order to anwser your request. In accordance with the Regulation(EU) 2016 / 679 of the European Parliament and of the Council of 27 April 2016 you have the right to request the access to and rectification or erasure of your personal data or restriction of processing concerning the data subject or to object to processing as well as the right to data portability. <a href="https://help-uk.maisonsdumonde.com/my-account-and-personal-information/how-can-i-exercise-my-rights-for-my-personal-data">You can exercise your rights by clicking on this link.</a> <a href="https://www.maisonsdumonde.com/UK/en/e/legal/security-and-confidentiality">You can find our Personal data Protection Policy here</a>',
  url: '/UK/en/e/legal/credits-and-legal-notices'
}];
export var LEGAL_NOTICE_GDPR = [{
  language: 'fr-FR',
  text: 'MAISONS DU MONDE FRANCE traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu\'un droit à la limitation et à la portabilité de vos données.Vous pouvez exercer vos droits en remplissant les champs ci - dessus. <a href="https://www.maisonsdumonde.com/FR/fr/e/legal/securite-et-confidentialite">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>'
}, {
  language: 'es-ES',
  text: 'MAISONS DU MONDE ESPAÑA SL trata sus datos personales para responder a su solicitud. De Conformidad con el Reglamento(UE) 2016 / 679 del Parlamento Europeo y del Consejo del 27 de abril de 2016 usted dispone de un derecho de acceso, rectificación, limitación u oposición al tratamiento y supresión de sus datos personales, así como de portabilidad de los mismos, rellenando el formulario anterior. <a href="https://www.maisonsdumonde.com/ES/es/statique/securite-et-confidentialite.htm">Para conocer nuestra Política de Privacidad, visite la sección“ Datos Personales” en nuestra página web haciendo clic en este enlace.</a>'
}, {
  language: 'it-IT',
  text: '"MAISONS DU MONDE ITALIE S.P.A tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento(UE) 2016 / 679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali. <a href="https://www.maisonsdumonde.com/IT/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy. Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci compilando il modulo sopra.</a>'
}, {
  language: 'de-DE',
  text: 'MAISONS DU MONDE ALLEMAGNE GmbH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte können Sie das Formular oben ausfüllenklicken. <a href="https://www.maisonsdumonde.com/DE/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>'
}, {
  language: 'fr-BE',
  text: 'MAISONS DU MONDE BELGIQUE SPRL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu\'un droit à la limitation et à la portabilité de vos données.Vous pouvez exercer vos droits en remplissant les champs ci - dessus. <a href="https://www.maisonsdumonde.com/BE/fr/statique/securite-et-confidentialite.htm">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>'
}, {
  language: 'de-AT',
  text: 'MAISONS DU MONDE ÖSTERREICH nutzt Ihre personenbezogenen Daten gem. Art. 6 Absatz 1 lit. b), c), f) Datenschutzgrundverordnung (DSGVO), um auf Ihre Anfrage zu antworten. Sie können bezüglich Ihrer bei uns verarbeiteten Daten gem. Art. 15-18, 20, 21 DSGVO jederzeit Auskunft, Berichtigung, Löschung, Beschränkung der Verarbeitung und Übertragung der Daten verlangen und der weiteren Verarbeitung jederzeit widersprechen. Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte können Sie das Formular oben ausfüllenklicken. <a href="https://www.maisonsdumonde.com/AT/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>'
}, {
  language: 'nl-BE',
  text: 'MAISONS DU MONDE BELGIQUE SPRL verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.Bij vragen kunt u door het bovenstaande formulier in te vullen. <a href="https://www.maisonsdumonde.com/BE/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>'
}, {
  language: 'de-CH',
  text: 'MAISONS DU MONDE SUISSE SARL nutzt Ihre personenbezogenen Daten, um auf Ihre Anfrage zu antworten. Nach der EU-Verordnung 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 haben Sie das Recht auf Einsichtnahme, Berichtigung, Einschränkung und Löschung der Sie betreffenden Daten. Für alle Anträge zur Geltendmachung Ihrer vorbezeichneten Rechte können Sie das Formular oben ausfüllenklicken. <a href="https://www.maisonsdumonde.com/CH/de/statique/securite-et-confidentialite.htm">Weitere Informationen zur Verarbeitung Ihrer Daten finden Sie unter.</a>'
}, {
  language: 'fr-CH',
  text: 'MAISONS DU MONDE SUISSE SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement (UE) 2016/679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu’un droit à la limitation et à la portabilité de vos données. Vous pouvez exercer vos droits en remplissant les champs ci-dessus. <a href="https://www.maisonsdumonde.com/CH/fr/statique/securite-et-confidentialite.htm">Concernant notre politique de collecte et traitement de vos données personnelles vous la trouverez en cliquant sur ce lien.</a>'
}, {
  language: 'it-CH',
  text: 'MAISONS DU MONDE SUISSE SARL  tratta i suoi dati personali per rispondere alla sua richiesta. Conformemente al Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio del 27 aprile 2016, l\'utente dispone di un diritto di accesso, rettifica, limitazione e cancellazione dei propri dati personali.Per ulteriori informazioni sui tuoi dati personali, non esitare a contattarci compilando il modulo sopra. <a href="https://www.maisonsdumonde.com/CH/it/statique/securite-et-confidentialite.htm">Puoi consultare qui la nostra informativa sulla privacy.</a>'
}, {
  language: 'fr-LU',
  text: 'MAISONS DU MONDE LUXEMBOURG SARL traite vos données personnelles pour répondre à votre demande. Conformément au Règlement(UE) 2016 / 679 du parlement Européen et du Conseil du 27 avril 2016, vous disposez d\'un droit d\'accès, de rectification, d\'effacement et d\'opposition de vos données personnelles ainsi qu\'un droit à la limitation et à la portabilité de vos données.Vous pouvez exercer vos droits en remplissant les champs ci - dessus. <a href="https://www.maisonsdumonde.com/LU/fr/statique/securite-et-confidentialite.htm">Concernant notre politique de protection des données personnelles vous la trouverez en cliquant sur ce lien.</a>'
}, {
  language: 'nl-NL',
  text: 'MAISONS DU MONDE FRANCE SAS verwerkt uw persoonsgegevens om uw verzoek te beantwoorden. Conform de Verordening(EU) 2016 / 679 van het Europees Parlement en de Raad van 27 april 2016 beschikt u over een recht op inzage, rectificatie, beperkte verwerking en verwijdering van uw persoonsgegevens.Bij vragen kunt u door het bovenstaande formulier in te vullen. <a href="https://www.maisonsdumonde.com/NL/nl/statique/securite-et-confidentialite.htm">Ons verzamelbeleid en beleid inzake de verwerking van uw persoonlijke gegevens vindt u door op de volgende link te klikken.</a>'
}, {
  language: 'pt-PT',
  text: 'MAISONS DU MONDE PORTUGAL recolhe e processa seus dados pessoais a fim de responder ao seu pedido. Em conformidade com o Regulamento(UE) 2016 / 679 do parlamento Europeu e do Conselho, de 27 de abril de 2016, dispõe do direito de acesso, de retificação, de eliminação e de oposição no que diz respeito aos seus dados pessoais, assim como do direito à limitação e à portabilidade dos seus dados.Pode também exercer o seu direito preenchendo o formulário acima. <a href="https://www.maisonsdumonde.com/PT/pt/statique/securite-et-confidentialite.htm">Para encontrar a nossa política de recolha e de processamento dos seus dados pessoais, clique nesta hiperligação.</a>'
}, {
  language: 'en-GB',
  text: 'MDM UK FURNITURE & DECORATION LIMITED S.L processes your data in order to anwser your request. In accordance with the Regulation(EU) 2016 / 679 of the European Parliament and of the Council of 27 April 2016 you have the right to request the access to and rectification or erasure of your personal data or restriction of processing concerning the data subject or to object to processing as well as the right to data portability.You can exercise your rights by filling the form above. <a href="https://www.maisonsdumonde.com/UK/en/e/legal/security-and-confidentiality">You can find our Personal data Protection Policy here.</a>'
}];
export var PRIVACY_POLICY = [{
  language: 'fr-FR',
  url: '/FR/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'es-ES',
  url: '/ES/es/e/legal/seguridad-y-confidencialidad'
}, {
  language: 'it-IT',
  url: '/IT/it/e/legal/sicurezza-e-riservatezza'
}, {
  language: 'de-DE',
  url: '/DE/de/e/legal/datenschutz'
}, {
  language: 'fr-BE',
  url: '/BE/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'de-AT',
  url: '/AT/de/e/legal/datenschutz'
}, {
  language: 'nl-BE',
  url: '/BE/nl/e/legal/veiligheid-en-vertrouwelijkheid'
}, {
  language: 'de-CH',
  url: '/CH/de/e/legal/datenschutz'
}, {
  language: 'fr-CH',
  url: '/CH/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'it-CH',
  url: '/CH/it/e/legal/sicurezza-e-riservatezza'
}, {
  language: 'fr-LU',
  url: '/LU/fr/e/legal/securite-et-confidentialite'
}, {
  language: 'nl-NL',
  url: '/NL/nl/e/legal/veiligheid-en-vertrouwelijkheid'
}, {
  language: 'pt-PT',
  url: '/PT/pt/e/legal/seguranca-e-confidencialidade'
}, {
  language: 'en-GB',
  url: '/UK/en/e/legal/security-and-confidentiality'
}];
export var CGU = [{
  language: 'fr-FR',
  links: [{
    label: 'Classement Référencement Offres - ',
    url: '/FR/fr/e/legal/classement-referencement-offres'
  }, {
    label: 'CGU Marketplace - ',
    url: '/FR/fr/e/legal/cgu-acheteurs-marketplace'
  }, {
    label: 'CGU Marketplace BUSINESS - ',
    url: '/FR/fr/e/legal/cgu-acheteurs-marketplace-business'
  }]
}];